import { render } from "./compass.vue?vue&type=template&id=b194ef5c&scoped=true"
import script from "./compass.vue?vue&type=script&lang=js"
export * from "./compass.vue?vue&type=script&lang=js"

import "./compass.vue?vue&type=style&index=0&id=b194ef5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b194ef5c"]])

export default __exports__